// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__34nCd","dragIcon":"Choice_dragIcon__2bize","left":"Choice_left__3kNlT","input":"Choice_input__Muhx_"};